// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"70":"34843f58","160":"e4920801","906":"bc1e30ec"}[chunkId] + ".css";
};